import type { ScriptOperation, ScriptTimelineLine } from '../../api/scripts';
import { uiText } from '../../i18n';

/** Result metadata is optional. Missing rows remain unknown rather than text-length estimates. */
export function serverTimeline(lines: Array<{ sid?: string }>, timeline: ScriptTimelineLine[] | null | undefined, seconds: number | null | undefined) {
  const rows = new Map((timeline ?? []).map(row => [row.line_key, row]));
  const T = lines.map(line => {
    const row = line.sid ? rows.get(line.sid) : undefined;
    if (!row || !Number.isFinite(row.start_ms) || row.start_ms < 0 || !Number.isFinite(row.duration_ms) || row.duration_ms <= 0)
      return { t: null, d: null };
    return { t: row.start_ms / 1000, d: row.duration_ms / 1000 };
  });
  const total = Number.isFinite(seconds) && (seconds ?? 0) > 0 ? seconds! : null;
  return { T, all: total };
}

/** A server download never falls back to a synthesized demonstration WAV. */
export async function serverProjectDownload(projectId: number | undefined, operation: ScriptOperation | undefined,
  read: (projectId: number, operation: ScriptOperation) => Promise<Blob>, name: string) {
  if (!Number.isSafeInteger(projectId) || (projectId ?? 0) <= 0 || !operation || operation.status !== 'ready')
    throw new Error(uiText('Результат проекта пока недоступен. Проверьте статус ещё раз.'));
  const data = await read(projectId!, operation);
  if (!data.size || !data.type.startsWith('audio/')) throw new Error(uiText('Не удалось открыть аудио проекта.'));
  return { data, name: (name || 'steos-project').replace(/[\\/:*?"<>|]+/g, ' ').trim() + '.mp3' };
}
